import { Component, effect, EventEmitter, inject, Output, signal, untracked } from '@angular/core';
import { HandelsgeschaeftStatus } from 'lion-api';
import { CustomerStore, InvestmentService, TradeTransactionStore } from '@shared/data';

@Component({
  selector: 'app-button-layout-ausfuehren',
  templateUrl: './button-layout-ausfuehren.component.html',
  styleUrl: './button-layout-ausfuehren.component.scss',
  standalone: false
})
export class ButtonLayoutAusfuehrenComponent {
  @Output() resetGeschaeftEventEmitter = new EventEmitter<boolean>();

  protected isPrintable = signal(false);
  protected showButtons = signal(true);

  protected tradeTransactionStore = inject(TradeTransactionStore);
  protected executeDisabled = this.tradeTransactionStore.executeDisabled;
  protected processing = this.tradeTransactionStore.processing;
  protected tradeTransactionIsProcessing = this.tradeTransactionStore.tradeTransactionIsProcessing;
  private tradeTransaction = this.tradeTransactionStore.tradeTransaction;
  private customerStore = inject(CustomerStore);
  protected selectedCustomer = this.customerStore.customer;

  private investmentService = inject(InvestmentService);

  constructor() {
    effect(() => {
      const status = this.tradeTransaction().status;
      untracked(() => {
        this.isPrintable.update(() => status === HandelsgeschaeftStatus.Success);
      });
    });
  }

  resetGeschaeft() {
    this.resetGeschaeftEventEmitter.emit(true);
  }

  printPage() {
    this.investmentService.print(this.tradeTransaction());
  }

  processExecute() {
    this.investmentService.processExecute(this.tradeTransaction());
  }
}
